<div class="slider-container">
  <div class="slider" [style.transform]="'translateX(-' + currentTransform + 'px)'">
    @for (image of slidingImgs(); track image) {
      <img #imageElement [src]="image.src" alt="Slide" />
    }
  </div>
  @if (slidingImgs().length > 1) {
    <button (click)="prevSlide()" class="nav-button prev"> <span>❮</span>
  </button>
}
@if (slidingImgs().length > 1) {
  <button (click)="nextSlide()" class="nav-button next"> <span>❯</span>
</button>
}

<!-- Dots Container -->
@if (slidingImgs().length > 1) {
  <div class="dots">
    @for (image of slidingImgs(); track image; let i = $index) {
      <span [class.active]="currentIndex === i"
        (click)="goToSlide(i)" (keydown.enter)="goToSlide(i)" (keydown.space)="goToSlide(i)" tabindex="0" role="button">
      </span>
    }
  </div>
}
</div>